import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import UserAgreementQuery from './UserAgreementQuery';

const UserAgreementConnectorApollo = ({ children }) => {
  const { loading, error, data } = useQuery(UserAgreementQuery);

  let result = {
    loading,
    error,
  };

  if (!loading) {
    result.rawData = data;
    result.agreements = data.me.agreements;
  }

  return children(result);
};

UserAgreementConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default UserAgreementConnectorApollo;
